import { isEmpty } from 'lodash';

const crawlers = [
  'Googlebot',
  'Bingbot',
  'DuckDuckBot',
  'Baiduspider',
  'Slurp',
  'facebot',
  'facebook',
  'oncrawl',
];

export const isCrawler = (uaString?: string | null | undefined) => {
  // Check that the UA string exists, prevents some malicious actors which
  // attempt to hit the site without a UA string, typically scrapers do this.
  return (
    isEmpty(uaString) ||
    crawlers.some(crawler => {
      const needle = (uaString || '').toLowerCase();
      return needle.includes(crawler.toLowerCase());
    })
  );
};

// using string accessor fixes error with "Error: Cannot find symbol for node: NODE_ENV"
// eslint-disable-next-line dot-notation
export const isProduction = () => process.env['NODE_ENV'] === 'production';

export const isBrowser = () => typeof window !== 'undefined';
